import React from "react";

const SvgIcnHelp = props => (
  <svg data-name="\u30EC\u30A4\u30E4\u30FC 1" width={24} height={24} {...props}>
    <path
      d="M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      fillRule="evenodd"
      fill="#fff"
    />
    <path
      d="M12.05 5.25c2.23 0 4.2 1.13 4.2 3.49a3.55 3.55 0 0 1-1.89 3.08c-1.12.79-1.54 1.1-1.54 2.15v.5h-2.29v-.56a3.35 3.35 0 0 1 1.71-3.11c.9-.62 1.47-1 1.47-1.92a1.58 1.58 0 0 0-1.79-1.57 1.72 1.72 0 0 0-1.84 1.84H7.75c-.09-2.84 2.15-3.9 4.3-3.9zm-.3 10.51a1.51 1.51 0 1 1 0 3 1.5 1.5 0 1 1 0-3z"
      fill="#fff"
    />
  </svg>
);

export default SvgIcnHelp;
